export default "__VITE_ASSET__CzUZDCJz__"